import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from "../../use-firebase.js"
import { useMediaQuery, getSubDomain } from "../../shared-functions.js"
import Logo from "./Logo.js";
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { List, ArrowUpRight } from "phosphor-react";

export default function TopNavbar(props) {

  const location = useLocation();
  const auth = useAuth();
  let isPageWide = useMediaQuery('(min-width: 600px)');
  // let subdomain = getSubDomain(window.location.host);

  // return (
  //   <Navbar justify fixed="top" variant="light" style={{ textAlign: 'center', paddingTop: 5, paddingBottom: 10, backgroundColor: '#13103C' }}>
  //     <Logo />
  //     { (location.pathname === '/builder' || location.pathname === '/settings') &&
  //       <>
  //         <Navbar.Toggle aria-controls="basic-navbar-nav" />
  //         <Navbar.Collapse id="basic-navbar-nav">
  //           <Nav activeKey={location.pathname} className="m-auto">
  //             <Nav.Link href="/builder"><h6>Builder</h6></Nav.Link>
  //             <Nav.Link href="/settings"><h6>Settings</h6></Nav.Link>
  //           </Nav>
  //         </Navbar.Collapse>
  //       </>
  //     }
  //   </Navbar>
  // );

  if (location.pathname === '/') {
    return (
      <Navbar justify expand="md" fixed="top" variant="dark" style={{ backgroundColor: '#100E15', borderBottom: '0px solid #111111', paddingTop: 5 }}>
        <Logo />
      </Navbar>
    )
  }

  if (location.pathname !== '/' &&
      location.pathname !== '/login' &&
      location.pathname !== '/signup'  &&
      location.pathname !== '/notfound'  &&
      location.pathname !== '/builder'  &&
      location.pathname !== '/settings' &&
      location.pathname !== '/onboarding' &&
      location.pathname !== '/connectwallet' &&
      location.pathname !== '/home' &&
      !location.pathname.startsWith('/dashboard')
    ) {
    return (
      <div></div>
    )
  }

  // if (location.pathname.match('/\/nft\//')) {
  //   return (
  //     <div></div>
  //   )
  // }

  if (!auth.user) {
    return (
      <Navbar justify expand="md" fixed="top" variant="light" style={{ backgroundColor: '#FFFFFF', paddingTop: 5 }}>
        <Logo />
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav activeKey={location.pathname} className="ml-auto">
            <Nav.Link href="/login"><h6>Login</h6></Nav.Link>
            <Nav.Link href="/signup"><h6>Sign up</h6></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  } else {
    return (
      <Navbar justify expand="md" fixed="top" variant="light" style={{ backgroundColor: '#FFFFFF', paddingTop: 5, paddingLeft: 20, paddingRight: 20 }}>
        <Logo />
        <Navbar.Toggle aria-controls="basic-navbar-nav"><List style={{ color: '#111111' }} /></Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <NavDropdown alignRight className="ml-auto" id="dropdown-button-drop-start" drop="down" title={'@' + auth.user.handle} >
            <NavDropdown.Item href="/dashboard">Dashboard</NavDropdown.Item>
            <NavDropdown.Item href={"https://moleculeclimate.com/" + auth.user.handle} target="_blank">My page <ArrowUpRight /></NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item style={{ color: 'red' }} onClick={() => { auth.signout() }}>Signout</NavDropdown.Item>
          </NavDropdown>
        </Navbar.Collapse>
      </Navbar>
    )
  };


}
